'use client';

import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface ScrollIndicatorProps {
  className?: string;
}

/**
 * Floating "scroll" mouse hint. Gently bobs up and down forever.
 * Pass `className` to control sizing, color (via text color → currentColor) and
 * responsive visibility — e.g. `hidden lg:block`.
 */
export default function ScrollIndicator({
  className = '',
}: ScrollIndicatorProps) {
  return (
    <motion.div
      animate={{ y: [-10, 10, -10] }}
      transition={{
        duration: 4,
        ease: 'easeInOut',
        repeat: Infinity,
      }}
      className={cn('w-fit text-[#F2F0EF]', className)}
    >
      <svg
        className="w-[4rem] h-auto aspect-[2.5/3.5]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M18 2H14C11.879 2.00232 9.84549 2.84591 8.3457 4.3457C6.84591 5.84549 6.00232 7.87898 6 10V22C6.00232 24.121 6.84591 26.1545 8.3457 27.6543C9.84549 29.1541 11.879 29.9977 14 30H18C20.121 29.9977 22.1545 29.1541 23.6543 27.6543C25.1541 26.1545 25.9977 24.121 26 22V10C25.9977 7.87898 25.1541 5.84549 23.6543 4.3457C22.1545 2.84591 20.121 2.00232 18 2ZM24 22C23.9983 23.5908 23.3657 25.116 22.2408 26.2408C21.116 27.3657 19.5908 27.9983 18 28H14C12.4092 27.9983 10.884 27.3657 9.75919 26.2408C8.63433 25.116 8.00165 23.5908 8 22V10C8.00165 8.40921 8.63433 6.88405 9.75919 5.75919C10.884 4.63433 12.4092 4.00165 14 4H18C19.5908 4.00165 21.116 4.63433 22.2408 5.75919C23.3657 6.88405 23.9983 8.40921 24 10V22ZM17 8V14C17 14.2652 16.8946 14.5196 16.7071 14.7071C16.5196 14.8946 16.2652 15 16 15C15.7348 15 15.4804 14.8946 15.2929 14.7071C15.1054 14.5196 15 14.2652 15 14V8C15 7.73478 15.1054 7.48043 15.2929 7.29289C15.4804 7.10536 15.7348 7 16 7C16.2652 7 16.5196 7.10536 16.7071 7.29289C16.8946 7.48043 17 7.73478 17 8Z"
          fill="currentColor"
        />
      </svg>
    </motion.div>
  );
}
